import BackArrowIcon from 'app/assets/icons/back-arrow.svg'
import IconButton from 'app/components/base/IconButton'

export interface BackLinkProps {
  onClick: () => void
}

const BackLink: RFC<BackLinkProps> = ({ onClick }) => (
  <IconButton
    aria-label="Back link"
    onClick={onClick}
    sx={{
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      ml: '0 !important',
      mt: '0 !important',
      left: 0
    }}
  >
    <BackArrowIcon />
  </IconButton>
)

export default BackLink
